
import React from "react";
import {
  Datagrid,
  DateField,
  List,
  TextField,
  ShowButton,
  EditButton,
} from "react-admin";

const TemplateList = (props) => {
  return (
    <List bulkActionButtons={false} {...props}>
      <Datagrid>
        <TextField
          label="ID"
          source="id"
        />
        <TextField
          label="Nombre"
          source="name"
        />
        <TextField
          label="Descripción"
          source="description"
        />
        <DateField
          label="Modificado en"
          source="updatedAt"
        />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default TemplateList;
